import { render } from "./PlacePageList.vue?vue&type=template&id=eda1b166&scoped=true&ts=true"
import script from "./PlacePageList.vue?vue&type=script&lang=ts"
export * from "./PlacePageList.vue?vue&type=script&lang=ts"

import "./PlacePageList.vue?vue&type=style&index=0&id=eda1b166&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eda1b166"]])

export default __exports__